// Define free shipping thresholds based on country (in cents)
const FREE_SHIPPING_THRESHOLDS = {
  NZ: 24900, // $249.00 NZD for New Zealand
  AU: 9900  // $99.00 AUD for Australia
};

// Country code to name mapping for international shipping message
const COUNTRY_NAMES = {
  US: 'United States',
  NZ: 'New Zealand',
  AU: 'Australia',
  // Add more countries as needed
  default: 'your country' // Fallback for unknown country codes
};

// Function to get the free shipping threshold based on Shopify country
function getFreeShippingThreshold(country) {
  return Object.prototype.hasOwnProperty.call(FREE_SHIPPING_THRESHOLDS, country)
    ? FREE_SHIPPING_THRESHOLDS[country]
    : null;
}

// Function to get the country name and preposition for display
function getCountryName(country) {
  if (country === 'NZ') {
    return { name: 'New Zealand', preposition: 'to' };
  }
  return { name: 'Australia', preposition: 'within' }; // Default to AU for simplicity
}

// Function to get the display name for a country code
function getCountryDisplayName(country) {
  return COUNTRY_NAMES[country] || COUNTRY_NAMES.default;
}

function checkShipping(subtotal) {
  const freeShippingElement = document.querySelector(".free_shipping");

  if (!freeShippingElement) return; // Exit if the element doesn't exist

  const country = Shopify?.country || 'AU'; // Fallback to AU if Shopify.country is unavailable
  const FREE_SHIPPING_THRESHOLD = getFreeShippingThreshold(country);

// Handle countries with NO threshold defined (i.e. null/undefined)
if (FREE_SHIPPING_THRESHOLD === null || FREE_SHIPPING_THRESHOLD === undefined) {
  let formattedAmount;
  try {
    formattedAmount = theme.Currency.formatMoney(2000, theme.settings.moneyWithCurrencyFormat);
    formattedAmount = formattedAmount.replace(/AUD|NZD/g, 'USD'); // Override currency if needed
  } catch (error) {
    formattedAmount = "$20.00 USD";
  }

  if (country !== 'US' && country !== 'NZ' && country !== 'AU') {
    freeShippingElement.innerHTML =
      "<div>Shipping is <strong>" +
      formattedAmount +
      "</strong> Worldwide.</div>" +
      "<div class='pn-progressbar'><div class='pn-progressbar_ind' style='width:100%'></div></div>";
  } else {
    const countryName = getCountryDisplayName(country);
    freeShippingElement.innerHTML =
      "<div>Shipping is <strong>" +
      formattedAmount +
      "</strong> to " + countryName + ".</div>" +
      "<div class='pn-progressbar'><div class='pn-progressbar_ind' style='width:100%'></div></div>";
  }
  return;
}

  const { name: countryName, preposition } = getCountryName(country);
  const percent = subtotal / (FREE_SHIPPING_THRESHOLD / 100);
  const remaining = Math.round(FREE_SHIPPING_THRESHOLD - subtotal);

  if (subtotal < FREE_SHIPPING_THRESHOLD) {
    let formattedRemaining;
    try {
      formattedRemaining = theme.Currency.formatMoney(remaining, theme.settings.moneyWithCurrencyFormat);
    } catch (error) {
      formattedRemaining = `${remaining / 100} ${country === 'NZ' ? 'NZD' : 'AUD'}`; // Fallback if formatting fails
    }
    freeShippingElement.innerHTML =
      "<div>You're <strong>" +
      formattedRemaining +
      "</strong> from <strong>Free Express Shipping </strong> " + preposition + " " + countryName + ".</div>" +
      "<div class='pn-progressbar'><div class='pn-progressbar_ind' style='width:" +
      percent +
      "%'></div></div>";
  } else {
    freeShippingElement.innerHTML =
      "<div>Yew! 🤙🏼 <strong>Free Express Shipping </strong>" + preposition + " " + countryName + ".</div>" +
      "<div class='pn-progressbar'><div class='pn-progressbar_ind' style='width:100%'></div></div>";
  }
}

// Select the cart drawer element
const cartDrawer = document.getElementById("CartDrawer");

// Callback function to run when mutations are observed
const observerCallback = function (mutationsList) {
  for (let mutation of mutationsList) {
    if (mutation.type === "attributes" && mutation.attributeName === "class") {
      if (cartDrawer.classList.contains("drawer--is-open")) {
        const subtotalElement = cartDrawer.querySelector("[data-subtotal]");
        if (!subtotalElement) {
          return; // Exit if subtotal element is missing
        }
        const subtotalElementContent = subtotalElement.textContent.trim();
        const subtotalMatch = subtotalElementContent.match(/[0-9]+[,.]?[0-9]*/); // Extract numeric part
        if (!subtotalMatch) {
          return; // Exit if no numeric value found
        }
        const subtotalValue = Math.round(
          parseFloat(subtotalMatch[0].replace(/[,]/g, '')) * 100
        ); // Convert to cents, remove commas
        checkShipping(subtotalValue);
      }
    }
  }
};

// Create a MutationObserver instance to watch for changes in the cart drawer
const drawerObserver = new MutationObserver(observerCallback);

// Start observing the cart drawer for changes in its class attribute
if (cartDrawer) {
  drawerObserver.observe(cartDrawer, {
    attributes: true,
    attributeFilter: ["class"],
  });
}

// Dynamically change Micro Size URLs
document.addEventListener('DOMContentLoaded', function() {
  const colorInputs = document.querySelectorAll('input[name="Color"]');
  const sizeLinks = document.querySelectorAll('.variant-input-wrap .variant-input');

  function updateSizeLinks(selectedColor) {
    sizeLinks.forEach(sizeLink => {
      if (sizeLink.dataset.baseUrl) { // Only update for Micro products
        const sizeVariants = sizeLink.getAttribute('data-variants');
        const variantsArray = sizeVariants.split(',');
        let variantId = '';

        variantsArray.forEach(variant => {
          const [color, id] = variant.split(':');
          if (color === selectedColor) {
            variantId = id;
          }
        });

        const baseUrl = sizeLink.getAttribute('data-base-url');
        sizeLink.href = `${baseUrl}?variant=${variantId}`;
      }
    });
  }

  colorInputs.forEach(colorInput => {
    colorInput.addEventListener('change', function() {
      const selectedColor = this.getAttribute('data-color-name');
      updateSizeLinks(selectedColor);
    });
  });

  sizeLinks.forEach(sizeLink => {
    sizeLink.addEventListener('click', function(event) {
      const selectedColorInput = document.querySelector('input[name="Color"]:checked');
      const selectedColor = selectedColorInput ? selectedColorInput.getAttribute('data-color-name') : null;
      if (selectedColor && sizeLink.dataset.baseUrl) { // Only update for Micro products
        updateSizeLinks(selectedColor);
      }
    });
  });

  // Trigger initial update on page load
  const selectedColorInput = document.querySelector('input[name="Color"]:checked');
  if (selectedColorInput) {
    const selectedColor = selectedColorInput.getAttribute('data-color-name');
    updateSizeLinks(selectedColor);
  }
});

// Function to set up the CM/IN toggle functionality
function setupSizeChartToggle(tooltip) {
  const cmButton = tooltip.querySelector("#cmButton");
  const inButton = tooltip.querySelector("#inButton");
  const centimetresTable = tooltip.querySelector("#centimetresTable");
  const inchesTable = tooltip.querySelector("#inchesTable");

  if (!cmButton || !inButton || !centimetresTable || !inchesTable) {
    return;
  }

  // Remove existing listeners by cloning the buttons
  cmButton.replaceWith(cmButton.cloneNode(true));
  inButton.replaceWith(inButton.cloneNode(true));

  const newCmButton = tooltip.querySelector("#cmButton");
  const newInButton = tooltip.querySelector("#inButton");

  // Attach event listeners to the toggle buttons
  newCmButton.addEventListener("click", function () {
    showCM(newCmButton, newInButton, centimetresTable, inchesTable);
  });

  newInButton.addEventListener("click", function () {
    showIN(newCmButton, newInButton, centimetresTable, inchesTable);
  });
}

// Function to show the centimetres table
function showCM(cmButton, inButton, centimetresTable, inchesTable) {
  centimetresTable.style.display = "block";
  inchesTable.style.display = "none";
  cmButton.classList.add("selected");
  inButton.classList.remove("selected");
}

// Function to show the inches table
function showIN(cmButton, inButton, centimetresTable, inchesTable) {
  centimetresTable.style.display = "none";
  inchesTable.style.display = "block";
  inButton.classList.add("selected");
  cmButton.classList.remove("selected");
}

document.addEventListener('DOMContentLoaded', function () {
  // Initialize toggle functionality on the product page (static elements)
  setupSizeChartToggle(document);

  // Handle dynamic tooltip toggles
  const tooltipTrigger = document.querySelector('tool-tip-trigger[data-tool-tip="size-chart"]');
  if (tooltipTrigger) {
    tooltipTrigger.addEventListener("click", function () {
      // Wait for the tooltip to open
      const tooltipCheckInterval = setInterval(() => {
        const tooltip = document.querySelector('tool-tip[data-tool-tip="size-chart"][data-tool-tip-open="true"]');
        if (tooltip) {
          clearInterval(tooltipCheckInterval); // Stop checking
          setupSizeChartToggle(tooltip); // Initialize toggle functionality for the tooltip
        }
      }, 50); // Check every 50ms
    });
  }

  var videoElements = document.querySelectorAll('video');

  videoElements.forEach(function(videoElement) {
    videoElement.controls = false;

    videoElement.addEventListener('play', function () {
      this.controls = false;
    });

    videoElement.addEventListener('pause', function () {
      this.controls = false;
    });
  });
});